import { Box, Typography, Button, Paper } from '@mui/material'
import ImgTag from '../../../../../components/ImgTag'
import { ImageLinks, LogoTypeSocial } from '../../../../../constants/image-link'

interface IAccountConnectionCardProps {
  name: string
  description: string
  buttonText: string | JSX.Element
  icon: LogoTypeSocial
  isNew?: boolean
  onClick?: () => void
  status?: string
}

const AccountConnectionCard = ({
  name,
  description,
  buttonText,
  icon,
  isNew,
  onClick,
  status = 'disabled',
}: IAccountConnectionCardProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box display="flex" alignItems="center">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            marginRight: 1,
          }}
        >
          <ImgTag imageUrl={ImageLinks[icon]} name={name} size={35} />
          {/* {icon == 'LOGO_FACEBOOK' && (
            <ImgTag
              imageUrl={ImageLinks['LOGO_INSTAGRAM']}
              name={name}
              size={35}
            />
          )} */}
        </Box>

        <Box>
          <Typography variant="h6">
            {name}{' '}
            {isNew && (
              <Typography variant="caption" color="secondary">
                (New)
              </Typography>
            )}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </Box>
      </Box>
      <Button
        disabled={status === 'disabled'}
        variant="contained"
        color="primary"
        sx={{ gap: 1 }}
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </Paper>
  )
}

export default AccountConnectionCard
